import { render, staticRenderFns } from "./draftBox.vue?vue&type=template&id=110a7204&scoped=true&"
import script from "./draftBox.vue?vue&type=script&lang=js&"
export * from "./draftBox.vue?vue&type=script&lang=js&"
import style0 from "./draftBox.vue?vue&type=style&index=0&id=110a7204&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110a7204",
  null
  
)

export default component.exports